<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid>

    <v-layout row wrap>
      <v-flex xs12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 90px; padding-right: 90px;' : 'padding-top: 15px; padding-bottom: 5px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">

              <v-flex xs12 sm4 md2 lg1
                :style="filtroComputed.filtroPerfilString().length < 10 ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 15px;' : '' : !$vuetify.breakpoint.smAndDown ? `margin-right: ${filtroComputed.filtroPerfilString().length * 3 + 40}px;` : ''"
              >
                <v-menu
                  v-model="filtro.perfil.opened"
                  :full-width="$vuetify.breakpoint.smAndDown"
                  :close-on-content-click="false"
                  offset-y transition="slide-y-transition"
                 >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroPerfilString() == 'Perfil'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroPerfilString()}}</v-btn>
                  <v-card :max-width="!$vuetify.breakpoint.xsOnly ? '230px' : ''">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="perfil in perfilComputed.filterList" :key="perfil.id">
                        <v-btn
                          @click="filtroFunctions().selecionarPerfil(perfil)"
                          :color="filtroComputed.perfilSelecionadoDescricaoString() == perfil.descricao ? 'primary' : 'themeGrey'"
                          round block
                          :outline="filtroComputed.perfilSelecionadoDescricaoString() != perfil.descricao"
                        >{{perfil.descricao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm3 md2 lg1>
                <v-menu
                  v-model="filtro.status.opened"
                  :close-on-content-click="false"
                  offset-y transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroStatusString() == 'Status'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroStatusString()}}</v-btn>
                  <v-card :max-width="!$vuetify.breakpoint.smAndDown ? '170px' : ''">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="status in statusList" :key="status.descricao">
                        <v-btn
                          @click="filtroFunctions().selecionarStatus(status)"
                          :color="filtroComputed.statusSelecionadoDescricaoString() == status.descricao ? 'primary' : 'themeGrey'"
                          round block
                          :outline="filtroComputed.statusSelecionadoDescricaoString() != status.descricao"
                        >{{status.descricao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe o nome do usuário"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>

            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container class="ml-82 mr-82 pa-24">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">Adicionar Usuário</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn id="addUsuarioId"
              color="secondary"
              icon
              dark
              @click="adicionarUsuario">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <v-flex xs12 >
        <v-layout row wrap class="scrollflex">
          <v-flex xs12 class="scrollflexcontent">
            <v-list class="pa-0" two-line>
              <v-toolbar height="56" color="primary">
                <v-flex xs4>
                  <v-toolbar-title class="subheading white--text">Usuário</v-toolbar-title>
                </v-flex>
                <v-flex xs2>
                  <v-toolbar-title class="subheading white--text">Perfil</v-toolbar-title>
                </v-flex>
                <v-flex xs3>
                  <v-toolbar-title class="subheading white--text">Grupo Vinculado</v-toolbar-title>
                </v-flex>
                <v-flex xs2>
                  <v-toolbar-title class="subheading white--text">Status</v-toolbar-title>
                </v-flex>
                <v-flex xs1 text-xs-right>
                  <v-toolbar-title class="subheading white--text">Editar</v-toolbar-title>
                </v-flex>
              </v-toolbar>
              <v-list-tile v-for="usuario in usuarioFilteredList" :id="'usuario-' + usuario.id" :key="usuario.id" avatar>
                <v-flex xs4>
                  <v-list-tile-content>
                    <template>
                      <v-list-tile-title :id="'usuario-' + usuario.id + '-nome'" class="themeGrey--text">
                        {{ usuario.nome }}
                      </v-list-tile-title>                                  
                      <v-list-tile-sub-title :id="'usuario-' + usuario.id + '-email'">
                        {{ usuario.email }}
                      </v-list-tile-sub-title>
                    </template>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs2>
                  <v-list-tile-content>
                    <span :id="'usuario-' + usuario.id + '-perfil'" class="themeGrey--text">
                      {{ usuario.perfil.descricao }}
                    </span>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs3>
                  <v-list-tile-content>
                    <span :id="'usuario-' + usuario.id + '-grupo'" class="themeGrey--text">{{ usuario.grupos.length != 0 ? usuario.grupos[0].nome : '' }}</span>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs2>
                  <v-list-tile-content>
                    <span :id="'usuario-' + usuario.id + '-status'" class="themeGrey--text">{{ usuario.ativo ? 'Ativo' : 'Inativo' }}</span>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs1 text-xs-right>
                  <v-btn :id="'usuario-' + usuario.id + '-editar-btn'"
                    color="primary"
                    icon
                    @click="editarUsuario(usuario.id)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile>
            </v-list>
            <br>
            <div class="text-xs-center">
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel">
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import perfil from '@/helpers/perfil';
import functions from '@/components/pages/usuarios/functions.js';
import usuarioHelper from '@/helpers/usuario-logado.js';

export default {
  name: 'GestaoUsuarios',
  data () {
    return {
      on: null,
      usuarioList: undefined,
      usuarioListFiltrado: undefined,
      filtro: {
        perfil: {
          opened: false,
          selecionado: null
        },
        status: {
          opened: false,
          selecionado: null
        },
        pesquisa: {
          opened: false,
          conteudo: ""
        },
      },
      statusList: [
        {
          descricao: 'Todos',
          ativo: null
        },
        {
          descricao: 'Ativos',
          ativo: true
        },
        {
          descricao: 'Inativos',
          ativo: false
        },
      ],
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ''
      }
    }
  },
  computed: {
    perfilComputed: function() {
      return perfil;
    },
    usuarioFilteredList: function() {
      const self = this;
      var filteredList = self.usuarioList;
      
      if (self.usuarioList != undefined) {
        filteredList = functions.filtro.perfil(filteredList, self.filtro.perfil.selecionado);
        filteredList = functions.filtro.status(filteredList, self.filtro.status.selecionado);
        filteredList = functions.filtro.busca(filteredList, self.filtro.pesquisa.conteudo);
        return filteredList;
      }
    },
    filtroComputed: function() {
      const self = this;
      return {
        filtroPerfilString: function() {
          if (self.filtro.perfil.selecionado) {
            return self.filtro.perfil.selecionado.descricao;
          } else if (self.filtro.perfil.selecionado == 'Todos') {
            return 'Todos'
          } else {
            return 'Perfil';
          }
        },
        perfilSelecionadoDescricaoString: function() {
          if (self.filtro.perfil.selecionado) {
            return self.filtro.perfil.selecionado.descricao;
          } else {
            return '';
          }
        },
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return 'Status';
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return '';
          }
        }
      }
    }
  },
  mounted: function() {
    this.carregaUsuarios();
    this.externalSnackbarMessage();
  },
  methods: {
    carregaUsuarios: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaTodosUsuarios`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.usuarioList = response.data;
        self.$store.commit('endLoading');
      });
    },
    adicionarUsuario: function() {
      this.$router.push('/GestaoUsuarios/CadastroUsuario');
    },
    editarUsuario: function(idUsuario) {
      this.$router.push('/GestaoUsuarios/CadastroUsuario/' + idUsuario);
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbar.sucesso = self.$route.params.snackbarSucesso;
        self.snackbar.mensagem = self.$route.params.snackbarText;
        self.snackbar.visivel = self.$route.params.snackbarMostrar;
      }
    },
    filtroFunctions: function() {
      const self = this;
      return {
        selecionarPerfil: function(perfil) {
          if (perfil) {
            self.filtro.perfil.selecionado = perfil;
            self.filtro.perfil.opened = false;
          }
        },
        selecionarStatus: function(status) {
          if (status) {
            self.filtro.status.selecionado = status;
            self.filtro.status.opened = false;
          }
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.scrollflex {
  overflow-x: auto;
}
.scrollflexcontent {
  min-width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/usuarios/GestaoUsuarios.vue